import React, { useRef, useState } from 'react'
import Card from '../../shared/card/Card'
import { ScrollView, View, Text, ActivityIndicator } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'

const MaInformationonline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        ids,
        total
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postMaOnline, loading } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState(false);
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')







    const handlesubmit = async (signatureDataURL: any) => {

        const data = {
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            completeOnline: true,
            essUserKey: intializestore.initializeData.userkey,
            entityId: personalstore.personalData?.entityId,
            personalExemptions: values?.personalExemptions,
            spouseExemptions: values?.spouseExemption,
            noofDependents: values?.dependents ? values?.dependents : null,
            additionalWithholdings: values?.additionalWithholding ? values?.additionalWithholding : null,
            totalNoofExemptions: total,
            additionalExemptions: ids,
            sign: signatureDataURL,
            maritalStatus: values?.martialstatus,
            claimExemptions: values?.claimNoExemptions
        }
        const response = await postMaOnline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'MA Information'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('mainformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}
export default MaInformationonline
